import { render, staticRenderFns } from "./SortSelect.vue?vue&type=template&id=64dd4997&scoped=true"
import script from "./SortSelect.vue?vue&type=script&lang=js"
export * from "./SortSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd4997",
  null
  
)

export default component.exports